import { render, staticRenderFns } from "./ModalEvent.vue?vue&type=template&id=646ee793"
import script from "./ModalEvent.vue?vue&type=script&lang=js"
export * from "./ModalEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports